/**
 * Emailing a client their scan or dashboard link (SF-91).
 *
 * The server builds the link and sends it only to the address on the client's
 * profile, so the browser sends nothing but which link and which origin. The
 * refusals are ordinary — email not configured yet, the hourly cap, sharing
 * off — and each gets copy that says what to do next rather than a status code.
 */
export type SendLinkKind = 'scan' | 'dashboard';

export interface SendLinkResult {
  sentAt: string;
  kind: SendLinkKind;
  /** Masked by the server: "a***@example.com". */
  to: string;
}

export class SendLinkError extends Error {
  constructor(public status: number) {
    super(sendLinkErrorMessage(status));
    this.name = 'SendLinkError';
  }
}

export const sendLinkErrorMessage = (status: number): string => {
  switch (status) {
    // 404 is the endpoint not deployed yet, which to a coach is the same thing.
    case 404:
    case 503:
      return "Email isn't set up yet — copy the link instead.";
    case 429:
      return "That's 5 emails this hour. Try again later or copy the link.";
    case 409:
      return 'Turn sharing on first.';
    case 400:
      return 'This client has no valid email — add one in Settings.';
    default:
      return "Couldn't send the email. Try again or copy the link.";
  }
};
